<template>
  <label :class="['le-checkbox', {'disabled': disabled}]" @click="onClick" @keydown.enter.space.prevent="onClick" @focus="onFocus" :aria-checked="ariaChecked" :tabindex="tabIndex" role="checkbox">
    <span :class="['indicator', {'checked': checked, 'indeterminate': indeterminate}]"></span>
    <span v-if="hasLabel" class="label"><slot>{{label}}</slot></span>
  </label>
</template>

<script>
  import CONSTS from '../../../consts/consts';

  export default {
    name: 'le-checkbox',
    props: {
      label: {
        type: String,
        required: false,
      },
      state: {
        type: [String, Boolean],
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      tabbable: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      onClick() {
        if (!this.disabled) {
          let newState;
          if (this.state === CONSTS.LE_CHECKBOX.STATES.UNCHECKED || this.state === false) {
            newState = true;
          } else {
            newState = false;
          }
          this.$emit('change', newState);
        }
      },
      onFocus() {
        if (!this.disabled) {
          this.$emit('focus');
        }
      },
    },
    computed: {
      hasLabel() {
        return !!this.label || !!this.$slots.default;
      },
      checked() {
        return this.state === true || this.state === CONSTS.LE_CHECKBOX.STATES.CHECKED;
      },
      ariaChecked() {
        return this.checked ? 'true' : 'false';
      },
      indeterminate() {
        return this.state === CONSTS.LE_CHECKBOX.STATES.INDETERMINATE;
      },
      tabIndex() {
        return this.tabbable ? '0' : null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .le-checkbox {
    font-family: $font-family-Roboto;
    display: inline-block;
    position: relative;
    cursor: pointer;

    .indicator {
      position: relative;
      top: 1px;
      display: inline-block;
      height: 12px;
      width: 12px;
      border-radius: 3px;
      @include themify {
        background-color: getColor('checkboxBackground');
        border: solid getColor('checkboxBorder') 1px;
      }
      &:hover:not(&.checked),
      &:hover:not(&.disabled)
      {
        @include themify {
          border-color: getColor('checkboxBorderHover');
        }
      }

      &.checked {
        @include themify {
          border-color: getColor('checkboxSelected');
          &:after {
            border: solid getColor('checkboxSelected');
            border-width: 0 1px 1px 0;
          }
        }
        &:after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 3px;
          height: 7px;
          transform: rotate(45deg);
        }
      }

      &.indeterminate {
        @include themify {
          border-color: getColor('checkboxSelected');
          &:after {
            background-color: getColor('checkboxSelected');
          }
        }
        &:after {
          content: '';
          position: absolute;
          left: 2px;
          top: 2px;
          width: 8px;
          height: 8px;
        }
      }
    }

    .label {
      font-size: $font-size-medium;
    }

    &.disabled {
      cursor: default;
      .indicator {
        @include themify{
          background-color: getColor('checkboxBackgroundDisabled');
          border: solid getColor('checkboxBorderDisabled') 1px;
          &.checked:after {
            border-width: 0 1px 1px 0;
            border-color: getColor('checkboxSelectedDisabled');
          }
          &.indeterminate:after {
            background-color: getColor('checkboxSelectedDisabled');
          }
        }
      }
    }
  }
</style>
